import React, { useContext, useEffect } from 'react'
import { isNull, omit } from 'lodash'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import CardWidget, { Colors } from '../../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../../components/skeletons/CardWidgetSkeleton'
import { PharmaciesDetailsFiltersContext } from '../../../../../context/PharmaciesDetailsFiltersContext'
import { formatNumber } from '../../../../../utils/Helpers'

const GET_PERCENT_TAKE_RATE = gql`
  query PercentTakeRate($filters: NewOrderFilter) {
    pharmaciesAggs(
      size: 0,
      filters: $filters,
      aggs: { TakeRate: { terms: { field: "pharmacyTakeRate" } } }
    ) {
      aggregations
    }
  }
`

const PercentTakeRate = (): JSX.Element => {
  const { filters } = useContext(PharmaciesDetailsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_PERCENT_TAKE_RATE,
    {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { orderCreatedAt: filters.createdAt, ...omit(filters, 'createdAt') }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  const percentData = isNull(data.pharmaciesAggs.aggregations.TakeRate.buckets) ? '0' : data.pharmaciesAggs.aggregations.TakeRate?.buckets[0]?.key

  const outPercentDate = percentData || 0

  return (
    <CardWidget
      title="Porcentagem do contrato"
      number={`${formatNumber(outPercentDate, 2)}%`}
      color={Colors.green}
    />
  )
}

export default PercentTakeRate
